import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { UnorderedList, ItemLink, Item, ListItem, Heading } from './styles';
import { propLink } from '../link-handler';

const List = ({ items, depth = 0 }) => (
  <UnorderedList $depth={depth}>
    {items &&
      items.map((item, i) => (
        <Fragment key={i}>
          <ListItem>
            {item.current ? (
              <Item>{item.label}</Item>
            ) : (
              <ItemLink $activePage={item.active} link={item}>
                {item.label}
              </ItemLink>
            )}
            {item.down && item.down.length > 0 && item.active && (
              <List items={item.down} depth={depth + 1} />
            )}
          </ListItem>
        </Fragment>
      ))}
  </UnorderedList>
);

List.propTypes = {
  items: PropTypes.array,
  depth: PropTypes.number,
};

const LegalSideBar = ({ hierarchy, heading, id, label }) => (
  <nav id={id} aria-label={label}>
    <Heading>{heading}</Heading>
    <List items={hierarchy.down} active />
  </nav>
);

LegalSideBar.propTypes = {
  hierarchy: PropTypes.shape({
    down: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        active: PropTypes.bool,
        current: PropTypes.bool,
        link: propLink,
      })
    ),
  }).isRequired,
  heading: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
};

export default LegalSideBar;
